import { Component, Input, OnInit, AfterViewInit, ViewChild, ViewChildren, QueryList, ElementRef, TemplateRef } from '@angular/core';

const PAGE_HEIGHT = 1123; // px, A4 at 96dpi

@Component({
  selector: 'app-template4',
  templateUrl: './template4.component.html',
  styleUrls: ['./template4.component.scss']
})
export class Template4Component implements OnInit {
  @Input() data: any;
  @Input() isThumbnail: boolean = false;

  @ViewChild('measureContainer') measureContainer!: ElementRef;
  @ViewChildren('sectionRefs', { read: ElementRef }) sectionRefs!: QueryList<ElementRef>;

  allSections: any[] = [];
  pages: any[][] = [];

  ngOnInit(): void {
    // if (this.data && Array.isArray(this.data.experience)) {
    //   this.data.experience.forEach(exp => {
    //     // Split after every full stop, trim, and filter out empty points
    //     exp.descriptionPoints = exp.description
    //       ? exp.description.split(/\.(?!\d)/) // split on period not followed by a digit
    //           .map(point => point.trim())
    //           .filter(point => point.length > 0)
    //       : [];
    //   });
    // }
  }
}
